// Query-string marker appended to the UBS sign-in popup's `redirect_uri`s
// so the callback only activates for popups initiated by UBS sign-in.
export const UBS_MODAL_AUTH_PARAM = 'ubsBrandValidationModalAuth';
